import { useNavigate } from "@tanstack/react-router";
import Fade from "components/UI/Animations/Fade/Fade";
import JoyStick from "components/UI/Animations/JoyStick/JoyStick";
import ButtonAnimation from "components/UI/ButtonAnimation/ButtonAnimation";
import useJoyStickNavigation, {
  joystickEvent,
} from "hooks/UseJoyStickNavigation";
import styles from "./Explanation.module.scss";
import { useEffect, useState } from "react";
export default function Explanation() {
  const [count, setCount] = useState(0);
  const [runAnimation, setRunAnimation] = useState(false);

  const navigate = useNavigate();

  const handleJoyStick = (event: joystickEvent) => {
    if (event === "enter") {
      navigate({ to: "/postcode" });
    }
  };

  useEffect(() => {
    // Initialize a timer that runs every 10 seconds
    const timer = setInterval(() => {
      // Trigger the animation at the 5-second mark
      setTimeout(() => {
        setRunAnimation(true);
        // Turn off the animation after it has run for 5 seconds
        const countTimer = setInterval(() => {
          setCount((prevCount) => (prevCount === 4 ? 0 : prevCount + 1));
        }, 250);
        setTimeout(() => {
          clearInterval(countTimer);
          setRunAnimation(false);
        }, 3000);
      }, 2000);
    }, 5000);

    // Clean up the timer when the component unmounts
    return () => clearInterval(timer);
  }, []);

  useJoyStickNavigation(handleJoyStick);

  return (
    <Fade>
      <div className={styles.explanation}>
        <div className={styles.inner}>
          <h1>Voor we beginnen</h1>
          <div className={styles.row}>
            <JoyStick runAnimation={runAnimation} count={count} type="info" />
            <p>
              Gebruik de pook om vragen te beantwoorden, dit doe je door naar
              links of naar rechts te bewegen
            </p>
          </div>
          <div className={styles.row}>
            <div className={styles.button}>
              <ButtonAnimation />
            </div>
            <p>Bevestigen doe je met de grote knop.</p>
          </div>
          <div className={styles.row}>
            <div className={styles.back}>
              <img src="/images/icons/back.svg" />
            </div>
            <p>
              Je vind deze knop boven in je scherm, hiermee kun je terug naar de
              vorige vraag
            </p>
          </div>
        </div>
        <div className={styles.buttonAnimationWrapper}>
          <div className={styles.buttonAnimation}>
            <ButtonAnimation />
            <p>Begrepen</p>
          </div>
        </div>
      </div>
    </Fade>
  );
}
